import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchAiLogRatingRequest = {
	aiRequestLogId: string;
	rating: boolean | null;
};

export const patchAiLogRating = createPatchEndpoint<PatchAiLogRatingRequest>(
	(request) => `/api/v3/open-ai/chat/logs/${request.aiRequestLogId}/vote`,
	{
		requestTransform: (request) => {
			const result: { rating: string | null } = { rating: null };

			if (request.rating !== null) {
				result.rating = request.rating ? 'positive' : 'negative';
			}

			return result;
		}
	}
);
